import React, { useEffect, useState } from 'react'
import { formValueSelector, reduxForm } from 'redux-form'
import { Row, Col } from 'react-bootstrap'
import { connect } from 'react-redux'
import { FORM_BUQUES } from '../../../../config/forms'
import { COLORES } from '../../../../config/colores'
import { Button } from '@material-ui/core'
import moment from 'moment'
import CamposCargaBuque from './CamposCargaBuque'
import { toast } from 'react-toastify'
import { agregarDetalleCarga } from '../../actions/TablaCargaBuquesActions'

function AltaDetalleCarga (props) {
  const { fechaAnuncio, showAdd, change: formChange, agregarDetalleCarga } = props
  const [show, setShow] = useState(showAdd)
  const actualizarFechas = (fechaD, fechaH) => {
    formChange('fechaCargaDesde', moment(fechaD).format('YYYY-MM-DD'))
    formChange('fechaCargaHasta', moment(fechaH).format('YYYY-MM-DD'))
  }

  useEffect(() => {
    let init = true
    if (init) {
      setShow(showAdd)
      init = false
    }
  }, [showAdd, setShow])

  const resetForm = () => {
    // actualizarFechas(new Date())
    formChange('exportador', null)
    formChange('cereal', null)
    formChange('toneladas', null)
  }

  const handleSubmit = () => {
    const { fechaCargaDesde, fechaCargaHasta, exportador, cereal, toneladas } = props
    formChange('fechaAnuncio', fechaAnuncio)

    if (!fechaCargaDesde) {
      formChange('fechaCargaDesde', moment(new Date()).format('YYYY-MM-DD'))
      formChange('fechaCargaHasta', moment(new Date()).format('YYYY-MM-DD'))
    }

    if (fechaCargaDesde && exportador && cereal) {
      const detalleCarga = []
      const cantidadDias = moment(fechaCargaHasta).diff(fechaCargaDesde, 'days') + 1

      if (cantidadDias === 1) {
        detalleCarga.push({
          fechaAnuncio: fechaAnuncio,
          exportador: exportador,
          cereal: cereal,
          fechaCarga: fechaCargaDesde,
          toneladas: toneladas || null
        })
      } else {
        const toneladasPorDia = Math.floor(toneladas / cantidadDias)
        const resto = toneladas % cantidadDias
        let currentDate = fechaCargaDesde

        for (let i = 0; i < cantidadDias; i++) {
          detalleCarga.push({
            fechaAnuncio: fechaAnuncio,
            exportador: exportador,
            cereal: cereal,
            fechaCarga: currentDate,
            toneladas: (i === cantidadDias) ? resto : toneladasPorDia
          })

          currentDate = moment(currentDate).add(1, 'days').format('YYYY-MM-DD')
        }
      }

      agregarDetalleCarga(detalleCarga)
      resetForm()
    } else if (!exportador) {
      toast.error('El exportador es un campo obligatorio')
    } else if (!cereal) {
      toast.error('El cereal es un campo obligatorio')
    }

    setShow(false)
  }

  return (
    <div style={{ marginTop: '2%' }}>
      {show
        ? <>
          <h6 style={{ fontWeight: 'bold', color: COLORES.grey.dark, padding: '0 2%' }}>
              Nuevo detalle de carga
          </h6>
          <Row
            style={{
              padding: '18px',
              margin: '0 auto 2% auto',
              border: '1px solid',
              borderColor: COLORES.grey.light,
              borderRadius: '18px'
            }}
          >
            <Col md={10}>
              <CamposCargaBuque actualizarFechas={actualizarFechas} />
            </Col>
            <Col md={2} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Button
                onClick={handleSubmit}
                size='medium'
                style={{ backgroundColor: COLORES.blue.primary, color: 'white' }}
              >
                              Agregar
              </Button>
            </Col>
          </Row>
        </>
        : <Button
          onClick={() => { setShow(true) }}
          size='small'
          variant='contained'
          style={{ backgroundColor: COLORES.violet, color: 'white', margin: '2%', padding: '8px' }}
        >
            Agregar nuevo detalle de carga
        </Button>
      }

    </div>
  )
}

const selector = formValueSelector(FORM_BUQUES)
const mapStateToProps = (state) => ({
  fechaCargaDesde: selector(state, 'fechaCargaDesde'),
  fechaCargaHasta: selector(state, 'fechaCargaHasta'),
  exportador: selector(state, 'exportador'),
  cereal: selector(state, 'cereal'),
  toneladas: selector(state, 'toneladas')
})

const mapActionsToProps = {
  agregarDetalleCarga
}

const withReduxForm = reduxForm({
  form: FORM_BUQUES
})

const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(withReduxForm(AltaDetalleCarga))
